export default __webpack_public_path__ + "static/media/3435 spice rack D top.16555cc5.png";